var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 322,
    viewBox: "0 0 25 322",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.9655,
    height: 24.9655,
    transform: "matrix(1 0 0 -1 0 321.778)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9655,
    height: 24.9655,
    transform: "matrix(1 0 0 -1 0 303.227)",
    fill: "#EFEFEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9655,
    height: 24.9655,
    transform: "matrix(1 0 0 -1 0 284.676)",
    fill: "#DFDFDF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9655,
    height: 24.9655,
    transform: "matrix(1 0 0 -1 0 266.125)",
    fill: "#CFCFCF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9655,
    height: 24.9655,
    transform: "matrix(1 0 0 -1 0 247.575)",
    fill: "#BFBFBF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9655,
    height: 24.9655,
    transform: "matrix(1 0 0 -1 0 229.024)",
    fill: "#AFAFAF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9655,
    height: 24.9655,
    transform: "matrix(1 0 0 -1 0 210.473)",
    fill: "#9F9F9F"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9655,
    height: 24.9655,
    transform: "matrix(1 0 0 -1 0 191.922)",
    fill: "#8F8F8F"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9655,
    height: 24.9655,
    transform: "matrix(1 0 0 -1 0 173.372)",
    fill: "#808080"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9655,
    height: 24.9655,
    transform: "matrix(1 0 0 -1 0 154.821)",
    fill: "#707070"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9655,
    height: 24.9655,
    transform: "matrix(1 0 0 -1 0 136.27)",
    fill: "#606060"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9655,
    height: 24.9655,
    transform: "matrix(1 0 0 -1 0 117.719)",
    fill: "#505050"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9655,
    height: 24.9655,
    transform: "matrix(1 0 0 -1 0 99.1686)",
    fill: "#404040"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9655,
    height: 24.9655,
    transform: "matrix(1 0 0 -1 0 80.6178)",
    fill: "#303030"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9655,
    height: 24.9655,
    transform: "matrix(1 0 0 -1 0 62.067)",
    fill: "#202020"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9655,
    height: 24.9655,
    transform: "matrix(1 0 0 -1 0 43.5162)",
    fill: "#101010"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9655,
    height: 24.9655,
    transform: "matrix(1 0 0 -1 0 24.9656)",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.45a9a45fe985972bd9a560b292a56f24.svg";
export { ForwardRef as ReactComponent };